import { render } from "./k-barcode.vue?vue&type=template&id=4cfb7838"
import script from "./k-barcode.vue?vue&type=script&lang=js"
export * from "./k-barcode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__